module.exports = __webpack_public_path__ + "static/media/chiapas_sancrsitobal.ee7082fd.png";